import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import AlertDecagram from '@mdi/svg/svg/alert-decagram.svg';

import TileIcon from 'src/components/Tile/TileIcon';
import styles from 'src/components/Tile/TileBadge.scss';


const TileBadge = ({ isSuperOffer }) => {
  const labelClassList = classNames(styles['tile-badge__label'], {
    [styles['tile-badge__label--super-offer']]: isSuperOffer
  });

  return (
    <div styleName="tile-badge">
      {isSuperOffer && (
        <TileIcon
          classModifier="super-offer"
          icon={ AlertDecagram }
        />
      )}
      <span className={ labelClassList }>Super oferta</span>
    </div>
  );
};

TileBadge.propTypes = {
  isSuperOffer: PropTypes.bool.isRequired
};

export default TileBadge;
